import api from "./api";

const StockIndentService = {
  save: (data) => api.post("/stockIndent/save", data),

  getAll: (
    companyId,
    employeeId,
    roleId,
    page = 1,
    limit = 10,
    search = "",
    status = "ALL"
  ) =>
    api.get(
      `/stockIndent/getAll/${companyId}/${employeeId}/${roleId}`,
      {
        params: {
          page,
          limit,
          search,
          status,
        },
      }
    ),

  getById: (id) => api.get(`/stockIndent/getById/${id}`),

  update: (id, data) => api.put(`/stockIndent/update/${id}`, data),

  approve: (id, data) => api.put(`/stockIndent/approve/${id}`, data),

  reject: (id, data) => api.put(`/stockIndent/reject/${id}`, data),

  cancel: (id, data) => api.put(`/stockIndent/cancel/${id}`, data),

  updateStatus: (id, data) => api.put(`/stockIndent/updatestatus/${id}`, data),

  delete: (id) => api.delete(`/stockIndent/${id}`),

  getAvailableStock: (companyId, projectId, storeId, itemId) =>
    api.get(
      `/stockIndent/available-stock/${companyId}/${projectId}/${storeId}/${itemId}`
    ),

  getVoucherNo: (projectId, storeId) =>
    api.get(`/stockIndent/generate-voucher/${projectId}/${storeId}`),
};

export default StockIndentService;
